import type { AllowedList } from '../types';

export function isPetitionInAllowedList(id: string, petitions: AllowedList) {
	return petitions.some(({ petitionId }) => petitionId === id);
}
